<template>
  <v-flex xs12 mb-2>
    <v-card @click="seleccionarRespuesta(respuesta)" :class="seen ? 'e-ejercicio-ejercicio-selecionado' : 'algo'" class="e-elevation--3 radius">
      <v-card-text>
        <p class="e-description-smallest mb-0 text-xs-center py-3">{{ respuesta }}</p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "SubCardFila",
  data () {
    return {
      seen: false,
      respuestaUser: []
    }
  },
  props: {
    respuesta: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    },
    isValidar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    seleccionarRespuesta(value) {
      this.seen = !this.seen
      if (this.isValidar) {
        if(this.seen){
            this.respuestaUser.push(value)
        } else {
            this.respuestaUser = this.respuestaUser.filter( data => data !== value )
        }
        const respuestaFinal = {
          answer: this.answer,
          userAnswer: this.respuestaUser
        }
        this.$emit('clicked', respuestaFinal)
      } else {
        const valueSelected = {
          selected: this.seen,
          value: value
        }
        this.$emit('clicked', valueSelected)
      }
    }
  }
}
</script>
